import React, { useContext } from "react";
import { EasybakeContext } from "../EasybakeProvider";
import { __ } from "i18n-for-browser";
import "../../config/i18n";
import analytics from "../../config/analytics";
import { StepList, Step } from "@react/react-spectrum/StepList";

export default function ConsoleSteps(props) {
  const { referrer } = props;
  const { page, dispatch } = useContext(EasybakeContext);

  function getIndex() {
    switch (page) {
        case 'signup':
            return 0
        case 'create':
            return 1
        case 'credinfo':
            return 2
        case 'accesstoken':
            return 3
        case 'helloworld':
            return 4
        case 'buildsomethingcool':
            return 5
        default:
            break;
    }
  }
  function changePage(e) {
    // console.log(e)
    if (getIndex() < e) {
        return
    }
    switch (e) {
        case 0:
            dispatch({ type: 'set-page', payload: { page: 'signup' } })
            break;
        case 1:
            dispatch({ type: 'set-page', payload: { page: 'create' } })
            break;
        case 2:
            dispatch({ type: 'set-page', payload: { page: 'credinfo' } })
            break;
        case 3:
            dispatch({ type: 'set-page', payload: { page: 'accesstoken' } })
            break;
        case 4:
            dispatch({ type: 'set-page', payload: { page: 'helloworld' } })
            break;
        case 5:
            dispatch({ type: 'set-page', payload: { page: 'buildsomethingcool' } })
            break;
        default:
            break;
    }
  }
  return (
    <div>
      <StepList 
        interaction="on" 
        selectedIndex={getIndex()}
        onChange={(e) => changePage(e)} 
        size="L">
        <Step>{__('signup_wizard_title1')}</Step>
        <Step>{__('signup_wizard_title2')}</Step>
        <Step>{__('signup_wizard_title3')}</Step>
        <Step>{__('signup_wizard_title4')}</Step>
        <Step>{__('signup_wizard_title5')}</Step>
        <Step>{__('signup_wizard_title6')}</Step>
      </StepList>
      <br />
    </div>
  );
}
